module.exports = __webpack_public_path__ + "img/l_Ionic.25b89b2d.svg";